import _ from 'lodash';
import {
  CHANGE_ELEMENTS_COUNT,
  START_FREE_TRIAL_INIT,
  START_FREE_TRIAL_DESTROY,
  CHANGE_FREE_TRIAL_COMPRESS,
} from './FloatingStartFreeTrial.actions';
/**
 * isVisible & isMounted two different fields are maintained with similar values to avoid
 * race condition between CHANGE_ELEMENTS_COUNT and START_FREE_TRIAL_INIT actions.
 * isMounted is required to remove extra padding in the footer if there is no banner.
 */
const INITIAL_STATE = {
  visibleElements: new Set(),
  compressingElements: new Set(),
  isCompressed: false,
  isVisible: true,
  isMounted: false,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CHANGE_ELEMENTS_COUNT: {
      const { isVisible: isElementVisible, target } = _.get(action, 'payload', null);
      const { visibleElements } = state;
      if (isElementVisible) {
        visibleElements.add(target);
      } else {
        visibleElements.delete(target);
      }
      return {
        ...state,
        visibleElements,
        isVisible: visibleElements.size === 0,
      };
    }
    case CHANGE_FREE_TRIAL_COMPRESS: {
      const { shouldCompressFreeTrial, target } = _.get(action, 'payload', null);
      const { compressingElements } = state;
      if (shouldCompressFreeTrial) {
        compressingElements.add(target);
      } else {
        compressingElements.delete(target);
      }
      return {
        ...state,
        compressingElements,
        isCompressed: compressingElements.size !== 0,
      };
    }
    case START_FREE_TRIAL_INIT: {
      return { ...state, isMounted: true };
    }
    case START_FREE_TRIAL_DESTROY: {
      return { ...state, isMounted: false };
    }
    default:
      return state;
  }
}
